import React from 'react';
import { Navigate } from 'react-router-dom';
import { checkLoginCookies, getGlid, getAk } from '../../utils';

const ProtectedRoute = ({
  element,
  requireAuth = true,
  requireState = false,
  stateProp = 'allowed',
  fallbackPath = '/personalloan'
}) => {
  const loginStatus = checkLoginCookies();
  const glid = getGlid();
  const ak = getAk();

  // Check authentication
  if (requireAuth && loginStatus !== 'login') {
    return <Navigate to={fallbackPath} replace />;
  }

  if (requireAuth && (!glid || !ak)) {
    return <Navigate to={fallbackPath} replace />;
  }

  // Check if route state is required (for pages that must be accessed through navigation)
  if (requireState) {
    const element_clone = React.cloneElement(element, {
      _requiresStateValidation: true
    });
    return element_clone;
  }

  return element;
};

export default ProtectedRoute;
